import { combineReducers } from 'redux';
import { ACTION_RANDOM_PERSON } from '../actions/types';
import { createLoadingReducer } from './utils';

const loading = createLoadingReducer(ACTION_RANDOM_PERSON);

export default combineReducers({ loading });
